import React, { useState, useEffect } from "react";
import { Avatar } from "@mui/material";
import ModalSkeleton from "./ModalSkeleton";
import IMG from "../assets/images/Companies_bg.png";
import "../assets/styles/appliedCraftmanModal.css";
import { apiHeader, imageUrl, pdfUrl, URL } from "../Config/apiUrl";
import { useHistory } from "react-router-dom";
import { Col, Row, Form, Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Get, Post } from "../Axios/AxiosFunctions";
import { toast } from "react-toastify";

let dummyPdf =
  "https://en.unesco.org/inclusivepolicylab/sites/default/files/dummy-pdf_2.pdf";

function ViewContractModal({
  open,
  setOpen,
  setContractsData,
  contractData: data,
  isCompany,
}) {
  const [isApiCall, setIsApiCall] = useState(false);
  const accessToken = useSelector((state) => state.authReducer.access_token);
  console.log(data);

  // handleSignSubmit
  const handleSignSubmit = async (e) => {
    if (isCompany) return;

    if (data?.status == "completed") return;

    const url = URL(`job/mark-assign?jobId=${data._id}`);
    setIsApiCall(true);
    const response = await Get(url, accessToken);
    setIsApiCall(false);

    if (response !== undefined) {
      toast.success("Contract signed successfully.");
      setContractsData((p) => p.filter((item) => item._id !== data._id));
      setOpen(false);
    }
  };

  console.log(
    isCompany
      ? `https://docs.google.com/viewerng/viewer?url=${pdfUrl}${data?.acceptedOfferletter}&embedded=true`
      : data?.status == "offered"
      ? data?.signedUrl
      : `https://docs.google.com/viewerng/viewer?url=${pdfUrl}${data?.acceptedOfferletter}&embedded=true`
  );

  // https://ac3c-103-244-178-85.au.ngrok.io/api/pdf/a6bbc1e8-be42-4228-8d43-3a5f19012ade.pdf

  return (
    <ModalSkeleton
      title="View Contract"
      open={open}
      setOpen={setOpen}
      size={"xl"}
      isBig
      fn={handleSignSubmit}
    >
      <section className="iframe-big">
        <iframe
          src={
            isCompany
              ? `https://docs.google.com/viewerng/viewer?url=${pdfUrl}${data?.acceptedOfferletter}&embedded=true`
              : data?.status == "offered"
              ? data?.signedUrl
              : `https://docs.google.com/viewerng/viewer?url=${pdfUrl}${data?.acceptedOfferletter}&embedded=true`
          }
          title="contract"
          className="iframe-contract"
        ></iframe>
      </section>
      <Modal.Footer>
        {data?.additionalDoc && (
          <Button
            disabled={isApiCall}
            variant="primary"
            style={{
              backgroundColor: "#28bad8",
            }}
            onClick={() =>
              window.open(`${pdfUrl}${data?.additionalDoc}`, "_blank")
            }
          >
            Read Additional Document
          </Button>
        )}
        {data?.status !== "completed" && (
          <Button
            disabled={isApiCall}
            variant="primary"
            onClick={handleSignSubmit}
          >
            {isApiCall ? "Please wait..." : "Submit Contract"}
          </Button>
        )}
      </Modal.Footer>
    </ModalSkeleton>
  );
}

export default ViewContractModal;
